"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ISubModelOptsSchema = exports.ISigmaSubModelOptsSchema = exports.ISpiceExternalIncludeOptsSchema = exports.ISpiceIncludeOptsSchema = exports.ISubModelOptsBase_Sigma_Schema = exports.ISubModelOptsBase_Spice_Schema = exports.ISubModelOptsBaseSchema = void 0;
exports.isSubModelSpiceExternalInclude = isSubModelSpiceExternalInclude;
exports.isSubModelSigmaSubModel = isSubModelSigmaSubModel;
const zod_1 = require("zod");
const ComponentSpiceModelDefinition_1 = require("./ComponentSpiceModelDefinition");
const IModelInfoBase_1 = require("../DesignModels/IModelInfoBase");
exports.ISubModelOptsBaseSchema = zod_1.z.object({
    type: zod_1.z.enum(['spice', 'sigma']),
    subModelId: zod_1.z.string(),
});
exports.ISubModelOptsBase_Spice_Schema = exports.ISubModelOptsBaseSchema.extend({
    type: zod_1.z.literal('spice'),
});
exports.ISubModelOptsBase_Sigma_Schema = exports.ISubModelOptsBaseSchema.extend({
    type: zod_1.z.literal('sigma'),
});
exports.ISpiceIncludeOptsSchema = exports.ISubModelOptsBase_Spice_Schema.extend({
    includedSubcircuits: zod_1.z.string().array().optional(),
    path: zod_1.z.string().optional(),
    contents: zod_1.z
        .string()
        .or(zod_1.z.custom((value) => typeof value === 'function'))
        .optional(),
});
exports.ISpiceExternalIncludeOptsSchema = exports.ISpiceIncludeOptsSchema.extend({
    baseModel: zod_1.z.string().optional().describe('The ID of the sigma model that this model implements'),
    modelInfo: ComponentSpiceModelDefinition_1.IComponentSpiceModelDefinitionSubcircuitSchema,
});
exports.ISigmaSubModelOptsSchema = exports.ISubModelOptsBase_Sigma_Schema.extend({
    modelId: zod_1.z.string().describe('The ID of the Sigma model to be included'),
    modelInfo: (0, IModelInfoBase_1.IModelInfoBaseSchema)(ComponentSpiceModelDefinition_1.IComponentSigmaModelSignalMapItemSchema),
});
exports.ISubModelOptsSchema = zod_1.z.discriminatedUnion('type', [
    exports.ISpiceExternalIncludeOptsSchema,
    exports.ISigmaSubModelOptsSchema,
]);
function isSubModelSpiceExternalInclude(opts) {
    return (opts?.type === 'spice' ||
        !opts?.type);
}
function isSubModelSigmaSubModel(opts) {
    return opts?.type === 'sigma';
}
//# sourceMappingURL=SpiceIncludeOpts.js.map